import styled from 'styled-components'
import colorsOptions from '../../fundamentals/colors-styles/constants'
import { motion } from 'framer-motion'

export const SidebarContainer = styled(motion.div)`
  position: fixed;
  box-sizing: border-box;
  background: ${colorsOptions.greys['grey-10']};
  height: calc(100vh - 50px);
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth ?? '25vw'};
  top: 48px;
  bottom: 0px;
  ${({ isRight }) => (isRight ? 'right: 0;' : 'left: 0;')}
  z-index: 1001;
  display: flex;
  flex-direction: column;
  border-radius: ${({ isRight }) =>
    isRight ? '16px 0 0 16px' : '0 16px 16px 0'};
  box-shadow: 0 8px 24px 0 rgba(120, 120, 135, 0.2);
  overflow: hidden;

  &,
  & * {
    box-sizing: border-box;
  }

  @media (max-width: 768px) {
    width: 100vw;
    border-radius: 0;
    height: 100%;
  }
`

export const ContentContainer = styled.div`
  height: 100%;
  width: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: inherit;
  border-radius: inherit;
  overflow: hidden;
`
